import { TextProps, Text, Flex } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React from 'react';

export type LabelTextProps = TextProps & {
  label?: string;
  labelProps?: TextProps;
  labelParams?: string[];
  params?: string[];
  col?: boolean;
  inline?: boolean;
  mt?: number;
  spaceBetween?: boolean;
};

export const LabeledText: React.FC<LabelTextProps> = ({
  label = '',
  labelProps,
  labelParams,
  params,
  children,
  col = false,
  inline,
  spaceBetween = false,
  ...props
}) => {
  const translate = useTranslate();
  return (
    <Flex
      mb={1}
      flexDirection={col ? 'column' : 'row'}
      justify={spaceBetween ? 'space-between' : undefined}
    >
      <Text
        cursor="text"
        fontSize="md"
        fontWeight="semibold"
        mr={1}
        {...labelProps}
      >
        {translate(label, labelParams)}
      </Text>
      <Text cursor="text" wordBreak="break-word" fontSize="md" {...props}>
        {translate(children, params)}
      </Text>
    </Flex>
  );
};
